import { css } from 'react-emotion'

const styles = {
  message: css({
    margin: '48px !important'
  }),
  addButton: css({
    margin: '0 8px'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Home/WelcomeMessageStyles.js